import { render, staticRenderFns } from "./treeNode.vue?vue&type=template&id=b05c8708"
import script from "./treeNode.vue?vue&type=script&lang=js"
export * from "./treeNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports